import { isIOS } from "react-device-detect";

export class System {
  static isPwaInstalled = () => {
    return (
      window.matchMedia("(display-mode: standalone)").matches ||
      localStorage.getItem("hidePWABanner") === "true"
    );
  };

  static isSupportPushNotification = () => {
    if (!isIOS) return true;
    const versionSupportPushNotification = {
      major: 16,
      minor: 4,
    };
    // check if device is iOS or iPadOS and version is greater than 16.4
    if (/iP(hone|ad)/.test(navigator.platform)) {
      const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
      if (v) {
        const major = parseInt(v[1], 10);
        const minor = parseInt(v[2], 10);
        return (
          (major > versionSupportPushNotification.major ||
            (major === versionSupportPushNotification.major &&
              minor >= versionSupportPushNotification.minor)) &&
          this.isPwaInstalled() &&
          isIOS
        );
      }
    }
  };

  static isLandscape = () => {
    return window.matchMedia("(orientation: landscape)").matches;
  };
}

export const urlB64ToUint8Array = (base64String: string) => {
  try {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  } catch (e) {
    return [];
  }
};

export const randomInt = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
